import { create } from 'zustand';

const initialVetState = {
  id: null,
  name: '',
  address: '',
  region: null,
  phone: '',
  email: '',
  web_page: '',
  notes: '',
  owner_naming: 'OWNER',
  pet_naming: 'PATIENT',
  unit_system: 'METRIC',
  hour_format: '24_HS',
  mobile_services: false,
  email_messaging: true,
  sells_planning_activity: true,
  sells_save_p1: false,
  sells_accept_suggested: true,
  sells_lock_price: false,
  default_sell_point: null,
  fiscal_id: '',
  fiscal_type: null,
  thumb_url: null,
  photo_url: null,
};

const useVetStore = create((set) => ({
  // Estado inicial
  vet: { ...initialVetState },

  // Acciones
  setVet: (vet) => set({ vet }),

  // Acciones específicas
  updateVet: (updates) => set((state) => ({
    vet: { ...state.vet, ...updates }
  })),

  // Resetear vet
  resetVet: () => set({ vet: { ...initialVetState } })
}));

export default useVetStore;

